module.exports = __webpack_public_path__ + "assets/totalamount.a0837f94.svg";